<template>
  <div class="relative flex min-h-screen w-screen overflow-hidden">
    <div
      class="animate move-remember bg-ontick-carbon-500 absolute inset-y-0 z-10 flex w-full max-w-lg flex-col items-center justify-center overflow-hidden overflow-y-auto bg-opacity-90 py-12 px-6 backdrop-blur-sm backdrop-opacity-90 backdrop-filter duration-300 lg:px-20 xl:px-24"
    >
      <div class="flex justify-center text-center">
        <div>
          <div class="flex justify-center">
            <span class="mx-auto" v-html="$icons.logo_public"></span>
          </div>
          <div>
            <h2 class="mt-6 text-3xl font-extrabold text-gray-300">
              Verificação de email
            </h2>
            <p class="mt-2 whitespace-normal text-sm text-gray-400">
              Um código será enviado para seu email cadastro na Ontick.
            </p>
          </div>
        </div>
      </div>

      <div
        is="transition"
        v-on:enter="enter"
        v-on:leave="leave"
        v-bind:css="false"
        appear
        mode="out-in"
      >
        <div :key="1" v-if="!success">
          <div class="relative whitespace-nowrap pt-6 pb-3">
            <label for="code" class="block text-sm font-medium text-gray-300">
              Código
            </label>
            <div class="mt-1">
              <PincodeInput
                v-model="code"
                :secure="false"
                :characterPreview="false"
                :length="6"
                name="code"
                v-validate="'required'"
                :error="errors.first('code')"
              />
              <p
                class="text-ontick-red-500 text-xs"
                v-show="errors.has('code')"
              >
                Campo obrigatório
              </p>
            </div>
          </div>

          <div>
            <ontick-button @click.native="validateEmail()" class="w-full"
              >Validar</ontick-button
            >
          </div>
        </div>
        <div :key="2" v-else class="flex justify-center">
          <div class="py-16">
            <success-icon
              :active="success"
              title="Email verificado com sucesso"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="relative w-0 flex-1 lg:block">
      <img
        class="absolute inset-0 h-full w-full object-cover"
        src="@/app/assets/imagens/fundo.png"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import PincodeInput from "vue-pincode-input";
import SuccessIcon from "@/app/shared/components/basic/ontick-success.component.vue";
import { Auth } from "aws-amplify";
import EventBus from "../../../shared/utils/event_bus";

export default {
  data() {
    return {
      user: {},
      code: "",
      form_state: true,
      success: false,
    };
  },
  components: {
    PincodeInput,
    SuccessIcon,
  },

  methods: {
    enter(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 0,
          scale: 1.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.8,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    validateEmail() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          Auth.verifyCurrentUserAttributeSubmit("email", this.code)
            .then(() => {
              this.success = true;
              sessionStorage.setItem("bypassCache", true);
              EventBus.$emit("LOGIN_SUCCESSFUL");
              setTimeout(() => {
                this.$router.push({
                  name: "Dashboard",
                  query: { ...this.$route.query },
                });
              }, 5000);
            })
            .catch((error) => {
              this.$swal({
                title: error.message,
                icon: "error",
                timer: 5000,
              });
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.animate {
  left: 0;
}

.move {
  left: 100%;
  transform: translate(-100%, 0);
}
.move-remember {
  left: 50%;
  transform: translate(-50%, 0);
}

div.vue-pincode-input-wrapper {
  @apply flex justify-center space-x-5;
}

input.vue-pincode-input {
  @apply bg-ontick-graphite-500 text-xl font-medium text-gray-300 shadow-lg;
  max-width: 43px;
  max-height: 43px;
  margin: 0px;
  transition: all 0.3s ease;
  &:focus {
    border: 2px solid #07a4ff;
  }
}
.input-tel__input {
  cursor: pointer;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  position: relative;
  width: 100%;
  padding: 0 12px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  z-index: 0;
  margin-left: -1px;
  height: 40px;
  min-height: 40px;
  @apply border-ontick-carbon-500  bg-ontick-steel-500 border text-sm font-medium text-gray-300 #{!important};
}
</style>
